import React from 'react';
import { motion } from 'framer-motion'; // Import Framer Motion
import Footur from '../components/footur';
import Header from '../components/Header';
import coverImage from '../assets/image/cover.png';

const AboutUs = () => {
  return (
    <div className='flex flex-col min-h-screen bg-[#F3F4F6]'>
      {/* Header */}
      <Header />

      {/* Cover Section */}
      <motion.div
        className='relative w-full'
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        {/* Background Image */}
        <img
          src={coverImage}
          alt='Cover'
          className='w-full h-[250px] sm:h-[300px] md:h-[400px] lg:h-[450px] object-cover'
        />

        {/* Overlay Description */}
        <div
          className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center text-white px-4 sm:px-8'
          style={{
            fontFamily: 'Inter',
          }}
        >
          <span className='text-base sm:text-lg md:text-xl lg:text-2xl font-medium leading-relaxed'>
            LeadGenPro simplifies motor insurance by providing the best quotes
            and empowering individuals to earn through lead generation. Join us
            to save, earn, and grow with ease!
          </span>
        </div>
      </motion.div>

      {/* "Why choose LeadGenPro!" Section */}
      <motion.div
        className='text-center font-sans mt-12 mb-6 px-4'
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <h1 className='text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold'>
          Why choose LeadGenPro!
        </h1>

        <div
          className='flex flex-col sm:flex-row justify-center gap-6 sm:gap-8 text-lg sm:text-xl md:text-2xl lg:text-3xl my-6'
          style={{ color: '#56D9B9' }}
        >
          <motion.span
            whileHover={{ scale: 1.1 }}
            transition={{ type: 'spring', stiffness: 300 }}
            className='text-center'
          >
            Competitive Quotes.
          </motion.span>
          <motion.span
            whileHover={{ scale: 1.1 }}
            transition={{ type: 'spring', stiffness: 300 }}
            className='text-center'
          >
            Hassle-Free Earnings.
          </motion.span>
          <motion.span
            whileHover={{ scale: 1.1 }}
            transition={{ type: 'spring', stiffness: 300 }}
            className='text-center'
          >
            Simplified Process.
          </motion.span>
        </div>
      </motion.div>

      {/* Vision and Mission Section */}
      <motion.div
        className='text-center font-sans px-4 mt-8 mb-12'
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.5 }}
      >
        <h2 className='text-xl sm:text-2xl md:text-3xl font-semibold my-6'>
          Vision and Mission
        </h2>
        <p className='text-gray-600 text-sm sm:text-base md:text-lg max-w-2xl mx-auto leading-relaxed'>
          Our mission is to revolutionize the motor insurance experience by:
          <br />
          Providing customers with competitive and transparent insurance
          quotations. Empowering Pro Lead Partners to earn and grow by
          generating high-quality leads without complex processes. Building a
          trusted network between customers and insurance providers. To become
          the most trusted platform for motor insurance, simplifying the process
          for customers while creating earning opportunities for individuals
          through lead generation.
        </p>
      </motion.div>

    </div>
  );
};

export default AboutUs;
